import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BackgroundOverlay } from "../FilterComp/index.styled";
import Info from "../Info";
// import { ReactComponent as CompareCrossSolid } from "../../Assets/Icons/CompareCrossSolid.svg";
import { ReactComponent as NewSortModel } from "../../Assets/Icons/NewSortModel.svg";
import { ReactComponent as NoKPIsSelectedIcon } from "../../Assets/Icons/NoKPIsSelectedIcon.svg";
import { ReactComponent as DeleteWeightage } from "../../Assets/Icons/DeleteWeightage.svg";
import { ReactComponent as Arrow } from "../../Assets/Icons/Arrow.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CrossSolid.svg";
import { viewSizeCalculator } from "../../utils";
import styled from "styled-components";
import CustomInput from "../Input";
import { StateAbbrvToName, stateList } from "../../Assets/MockData";
import { data, hospitalsList } from "./MockData";
import { states } from "../../Configs/config";
import HospitalListCard from "../HospitalList/HospitalListCard";
import {
  CenterDescription,
  CenterTitle,
  CenterTitleWrapper,
  CenterWrapper,
  HorizontalLine,
  HospitalCardWrapper,
  NoKPISelectedDescription,
  NoKPISelectedWrapper,
  SingleWeightageWrapper,
  SliderContainer,
  WeightageContainer,
  WeightageInputContainer,
  IconWrapper,
  Popup,
  PopupHeader,
  PopupScrollWrapper,
  CenterPopup,
  RightPopup,
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
  Reset,
  Title,
  TitleSection,
  FixedButtonContainer,
  Button,
} from "./index.styled";
import Slider from "./Slider";
import { AnimatePresence, motion } from "framer-motion";
import { setSortingModelVisibility } from "../../Redux/sortingModel/sortingModel.actions";

const CATEGORY_MAP = {
  "Core Weightages": "CoreWeightages",
  "Facility Types": "Facility",
  "Ownership Types": "Ownership",
  "Financial & Operational Metrics": "Financial",
  "Oncology Focus - Procedure Volume (2023)": "Oncology",
  "Quality of care": "QualityOfCare",
  "Cancer Incidence": "CancerIncidence",
};

const SortingModel = ({
}) => {
  const [inputValue, setInputValue] = useState("");
  const [ratings, setRatings] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    CoreWeightages: [],
    Facility: [],
    Ownership: [],
    Financial: [],
    Oncology: [],
    QualityOfCare: [],
    CancerIncidence: [],
  });
  const [openIndexes, setOpenIndexes] = useState(data.map((_, index) => index));
  const [scrollStates, setScrollStates] = useState({});
  const scrollRaf = useRef({});

  const handleScroll = (e, id) => {
    if (scrollRaf.current[id]) {
      cancelAnimationFrame(scrollRaf.current[id]);
    }

    scrollRaf.current[id] = requestAnimationFrame(() => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 5;

      setScrollStates((prev) => {
        if (prev[id] === atBottom) return prev;
        return { ...prev, [id]: atBottom };
      });
    });
  };

  const toggleAccordion = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleSliderChange = (label) => (value) => {
    setRatings((prev) => ({ ...prev, [label]: value }));
  };

  const handleRemoveWeightage = (category, label) => {
    setSelectedOptions((prev) => {
      const updatedCategoryValues = prev[category].filter(
        (item) => item !== label,
      );
      return {
        ...prev,
        [category]: updatedCategoryValues,
      };
    });

    setRatings((prev) => {
      const updatedRatings = { ...prev };
      delete updatedRatings[label];
      return updatedRatings;
    });
  };

  const getFilteredStateSuggestions = (input) => {
    if (!input) return stateList || [];

    const lowerInput = input.toLowerCase();
    return stateList.filter((state) => {
      if (!state) return false;
      const lowerAbbr = state.toLowerCase();
      const lowerName = (StateAbbrvToName[state] || "").toLowerCase();
      return lowerAbbr.includes(lowerInput) || lowerName.includes(lowerInput);
    });
  };

  const isSelectionEmpty = Object.values(selectedOptions).every(
    (arr) => arr.length === 0,
  );

  const handleCheckboxChange = (category, label, checked) => {
    const categoryKey = CATEGORY_MAP[category];

    setSelectedOptions((prev) => {
      const currentCategoryValues = new Set(prev[categoryKey]);

      if (checked) {
        currentCategoryValues.add(label);
      } else {
        currentCategoryValues.delete(label);
      }

      return {
        ...prev,
        [categoryKey]: Array.from(currentCategoryValues),
      };
    });
  };

  const handleInputChange = (name, value, isFacility = false) => {
    if (name === "state") {
      setInputValue(value);
      return;
    }

    if (value === "") {
      handleSliderChange(name)("");
      return;
    }

    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      handleSliderChange(name)(value);
    } else {
      console.warn(`Invalid number for ${name}:`, value);
    }
  };

  const handleStartSimulation = () => {
    console.log("start simulation");
    console.log("ratings", ratings);
  };

  const dispatch = useDispatch();
  const isSelectModelVisible = useSelector((state) => state.sortingModel.isVisible);

  const handleClosePopup = () => {
    dispatch(setSortingModelVisibility(false));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleClosePopup();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const allOptions = Object.entries(selectedOptions).flatMap(
    ([category, values]) => values.map((label) => ({ category, label })),
  );

  return (
    <>
      <BackgroundOverlay
        onClick={handleClosePopup}
        isPopupVisible={isSelectModelVisible}
      />
      <Popup isPopupVisible={isSelectModelVisible}>
        <PopupHeader>
          <TitleSection>
            <Title>Select Hospital KPIs</Title>
          </TitleSection>
          <Info
            showArrow={false}
            config={{
              tooltipText: "Close",
              position: "top",
            }}
          >
            <IconWrapper onClick={handleClosePopup}>
              {/* <CompareCrossSolid /> */}
              <CloseIcon/>
            </IconWrapper>
          </Info>
        </PopupHeader>
        <PopupScrollWrapper 
          onScroll={(e) => handleScroll(e, "popup")}
          isScrolledToBottom={scrollStates["popup"]}
        >
          {data.map((el, ind) => (
            <MainContainer key={ind}>
              <HeaderSection isFirst={ind === 0 || openIndexes.includes(ind-1)} onClick={() => toggleAccordion(ind)} open={openIndexes.includes(ind)}>
                {el.category}
                <Arrow/>
              </HeaderSection>
              <AnimatePresence initial={true}>
                {openIndexes.includes(ind) && (
                  <ContentWrapper
                    layout
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <RowContainer>
                      {el.fields.map((ele, ind) => (
                        <CheckboxContainer key={ind}>
                          <input
                            style={{
                              cursor: "pointer",
                              accentColor: "#F96250",
                              width: viewSizeCalculator(1.063),
                              height: viewSizeCalculator(1.063),
                            }}
                            type="checkbox"
                            id={ele.label}
                            onChange={(e) =>
                              handleCheckboxChange(
                                el.category,
                                ele.label,
                                e.target.checked,
                              )
                            }
                            checked={selectedOptions[
                              CATEGORY_MAP[el.category]
                            ].includes(ele.label)}
                          />
                          <CheckboxLabel htmlFor={ele.label}>
                            {ele.label}
                          </CheckboxLabel>
                        </CheckboxContainer>
                      ))}
                    </RowContainer>
                  </ContentWrapper>
                )}
              </AnimatePresence>
            </MainContainer>
          ))}
        </PopupScrollWrapper>

        <CenterPopup isSelectionEmpty={isSelectionEmpty}>
          <CenterWrapper>
            <CenterTitleWrapper>
              <NewSortModel />
              <CenterTitle>
                {isSelectionEmpty ? "Score Builder" : "Untitled Model"}
              </CenterTitle>
            </CenterTitleWrapper>
            <CenterDescription>
              Assign a weight to each KPI by selecting a value between 1 and 10
            </CenterDescription>
          </CenterWrapper>
          {isSelectionEmpty && (
            <NoKPISelectedWrapper>
              <NoKPIsSelectedIcon />
              <NoKPISelectedDescription>
                Select KPIs from the left panel to begin setting up your score
                builder
              </NoKPISelectedDescription>
            </NoKPISelectedWrapper>
          )}
          {!isSelectionEmpty && (
            <>
              <PopupScrollWrapper>
                <AnimatePresence mode="popLayout">
                  {allOptions.map(({ category, label }, index) => (
                    <motion.div key={label}>
                      <WeightageContainer
                        layout
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{
                          type: "spring",
                          stiffness: 300,
                          damping: 25,
                        }}
                      >
                        <SingleWeightageWrapper isLast={allOptions.length >= 5 && index === allOptions.length - 1}>
                          <SliderContainer>
                            <Slider
                              label={label}
                              rating={ratings[label] ?? 5}
                              onChange={handleSliderChange(label)}
                            />
                          </SliderContainer>
                          <WeightageInputContainer>
                            <CustomInput
                              placeholder={"Weightage"}
                              dropdown={false}
                              label={"Weightage"}
                              name={label}
                              value={ratings[label] ?? 5}
                              onChange={handleInputChange}
                              error={false}
                              showError={false}
                            />
                          </WeightageInputContainer>
                          <Info
                            showArrow={false}
                            config={{
                              tooltipText: "Remove Weightage",
                              position: "top",
                            }}
                          >
                            <DeleteWeightage
                              onClick={() =>
                                handleRemoveWeightage(category, label)
                              }
                            />
                          </Info>
                        </SingleWeightageWrapper>
                      </WeightageContainer>

                      {index !== allOptions.length - 1 && <HorizontalLine />}
                    </motion.div>
                  ))}
                </AnimatePresence>
              </PopupScrollWrapper>

              <FixedButtonContainer>
                <Button
                  color={"#3333333"}
                  backgroundColor={"#ffffff"}
                  borderColor={"#333333"}
                  onClick={handleClosePopup}
                >
                  Cancel
                </Button>
                <Button
                  color={"#ffffff"}
                  backgroundColor={"#333333"}
                  borderColor={"#000000"}
                  // onClick={onProceed}
                >
                  Save
                </Button>
              </FixedButtonContainer>
            </>
          )}
        </CenterPopup>

        <RightPopup>
          <PopupHeader>
            <TitleSection>
              <Title>Simulator</Title>
            </TitleSection>
            <Info
              showArrow={false}
              config={{
                tooltipText: "Start Simulation",
                position: "top",
              }}
            >
              <Reset onClick={handleStartSimulation}>Start</Reset>
            </Info>
          </PopupHeader>
          <CustomInput
            placeholder={"Choose a state to begin the simulation"}
            dropdown={true}
            label={"State"}
            name="state"
            value={
              inputValue
                ? states[inputValue] !== undefined
                  ? `${states[inputValue]} (${inputValue})`
                  : inputValue
                : ""
            }
            onChange={handleInputChange}
            suggestions={getFilteredStateSuggestions()}
            suggestionLoader={false}
            onNoMatch={() => {}}
          />
          <PopupScrollWrapper
            onScroll={(e) => handleScroll(e, "right")}
            isScrolledToBottom={scrollStates["right"]}
          >
            <HospitalCardWrapper>
              {hospitalsList?.map((ele, i) => (
                <HospitalListCard
                  data={ele}
                  key={i}
                  sortingLabel={""}
                />
              ))}
            </HospitalCardWrapper>
          </PopupScrollWrapper>
        </RightPopup>
      </Popup>
    </>
  );
};

export default SortingModel;

const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  width: 100%;
`;
